import { render, staticRenderFns } from "./AiInputSchemaEditor.vue?vue&type=template&id=668cb15d&scoped=true"
import script from "./AiInputSchemaEditor.vue?vue&type=script&lang=js"
export * from "./AiInputSchemaEditor.vue?vue&type=script&lang=js"
import style0 from "./AiInputSchemaEditor.vue?vue&type=style&index=0&id=668cb15d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668cb15d",
  null
  
)

export default component.exports